import { lazy, type ComponentType, type LazyExoticComponent } from "react";

/**
 * React.lazy for a named export (route modules rarely use default exports).
 * Props typed loosely so LazyExoticComponent stays assignable to react-router
 * `component` (nested @types/react conflict otherwise).
 */
function lazyNamed(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- route props vary; router needs ComponentType<any>
  loader: () => Promise<Record<string, ComponentType<any>>>,
  exportName: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- see above
): LazyExoticComponent<ComponentType<any>> {
  return lazy(async () => {
    const mod = await loader();
    const Component = mod[exportName];
    if (!Component) {
      throw new Error(`[lazyNamed] Missing export "${exportName}"`);
    }
    return { default: Component };
  });
}

export { lazyNamed };
